<template>
  <section class="section section-average bg-primary-color-light">
    <div class="container has-background-white">
      <div class="content">
        <div class="columns">
          <div class="column is-1">
            <figure class="media-left">
              <p class="image is-64x64">
                <img src="./../assets/img/icons/icon_average.png">
              </p>
            </figure>
          </div>
          <div class="column is-7">
            <article class="media">
              <div class="media-content">
                <h3>Autostrom in Deutschland </h3>
                <p><strong>Derzeit durchschnittlicher Gesamtpreis<sup>4</sup></strong></p>
              </div>
            </article>
          </div>
          <div class="column">
            <div class="media-right">
              <span v-if="averagePrice" class="preis second-color">  {{averagePrice}} €</span>
              <pulse-loader v-else :loading="loader.loading" :color="loader.color" :size="loader.size"></pulse-loader>
              <strong>im Monat</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from "axios";
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    name: "Average",

    data() {
      return {
        consumption: 0,
        averagePrice: null,
        error: null,
        loader: {
          color: '#2942ad',
          size: '10px',
          loading:true
        }
      }
    },
    mounted() {
      this.getAverage();
    },
    methods: {
      getAverage() {
        this.$root.$on('average', data => {
          this.averagePrice = false;
          // this.costs = data;
          this.consumption = Math.round( data );
          this.loader.loading = true;

          const ap = 0.220515789;
          const gp = 102.81;

          this.averagePrice = (ap * this.consumption + gp).toFixed(2);

          this.$root.$emit('calculating', false);
        })
      },
    },
    components:{
      PulseLoader
    }
  }
</script>

<style scoped>

</style>
